/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendInvitationAcceptDto } from '../../models/backend-invitation-accept-dto';
import { BackendInvitationAcceptRequestDto } from '../../models/backend-invitation-accept-request-dto';

export interface AccessInvitationsAcceptCreate$Params {
  body: BackendInvitationAcceptRequestDto;
}

export function accessInvitationsAcceptCreate(
  http: HttpClient,
  rootUrl: string,
  params: AccessInvitationsAcceptCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendInvitationAcceptDto>> {
  const rb = new RequestBuilder(rootUrl, accessInvitationsAcceptCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendInvitationAcceptDto>;
    }),
  );
}

accessInvitationsAcceptCreate.PATH = '/api/access/invitations/accept/';
